<template>
    <div>
        <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
                <!-- <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
              <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
                v-clipboard:success="onCopy" v-clipboard:error="onError"><i class="fa fa-copy mr-1" />Copy!
              </b-dropdown-item>
              <b-dropdown-item @click="checkDataExcel(json_data)">
                <download-excel :data="json_data" :fields="json_fields" :name="fileName">
                  <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                </download-excel>
              </b-dropdown-item>
              <b-dropdown-item>
                <download-excel :data="dataExport" :fields="json_fields" :name="fileName">
                  <i class="fa fa-file-excel-o mr-1" />Export Excel All
                </download-excel>
              </b-dropdown-item>
            </b-dropdown> -->
            </div>
            <div class="d-flex flex-column justify-content-center">
                <a-checkbox @change="getAutoRefresh(refresh)">
                    รีเฟรชอัตโนมัติ {{ (this.refresh) ? myVal : '' }}
                </a-checkbox>
            </div>
            <div class="d-flex flex-column justify-content-center">
                <a class="btn btn-primary" href="javascript: void(0);" @click="getDataProvider()"><i
                        class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h5>ข้อมูลการเติมเงิน-ถอนเงิน ผู้ให้บริการ Peer2Pay</h5>
                <hr>
                <div class="card-header card-header-flex">
                    <div class="d-flex flex-column justify-content-center mr-auto">
                        <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
                            <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
                                v-clipboard:success="onCopy" v-clipboard:error="onError"><i
                                    class="fa fa-copy mr-1" />Copy!
                            </b-dropdown-item>
                            <b-dropdown-item @click="checkDataExcel(json_data)">
                                <download-excel :data="json_data" :fields="json_fields" name="Export Peer2Pay">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                                </download-excel>
                            </b-dropdown-item>
                            <b-dropdown-item>
                                <download-excel :data="dataExport" :fields="json_fields" name="Export All Peer2Pay">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel All
                                </download-excel>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <a-table :columns="columns" :dataSource="dataPeer2Pay.provider" :loading="isLoading"
                    :row-selection="rowSelection" rowKey='username' :pagination="pagination">
                </a-table>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h5>ข้อมูลการเติมเงิน-ถอนเงิน ผู้ให้บริการ HengPay</h5>
                <hr>
                <div class="card-header card-header-flex">
                    <div class="d-flex flex-column justify-content-center mr-auto">
                        <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
                            <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeysHengPay)"
                                v-clipboard:success="onCopyHengPay" v-clipboard:error="onError"><i
                                    class="fa fa-copy mr-1" />Copy!
                            </b-dropdown-item>
                            <b-dropdown-item @click="checkDataExcel(json_dataHengPay)">
                                <download-excel :data="json_dataHengPay" :fields="json_fields" name="Export HengPay">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                                </download-excel>
                            </b-dropdown-item>
                            <b-dropdown-item>
                                <download-excel :data="dataExportHengPay" :fields="json_fields" name="Export All HengPay">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel All
                                </download-excel>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <a-table :columns="columns" :dataSource="dataHengPay.provider" :loading="isLoading"
                    :row-selection="rowSelectionHengPay" rowKey='username' :pagination="pagination">
                </a-table>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h5>ข้อมูลการเติมเงิน-ถอนเงิน ผู้ให้บริการ Thaiking</h5>
                <hr>
                <div class="card-header card-header-flex">
                    <div class="d-flex flex-column justify-content-center mr-auto">
                        <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
                            <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeysThaiking)"
                                v-clipboard:success="onCopyThaiking" v-clipboard:error="onError"><i
                                    class="fa fa-copy mr-1" />Copy!
                            </b-dropdown-item>
                            <b-dropdown-item @click="checkDataExcel(json_dataThaiking)">
                                <download-excel :data="json_dataThaiking" :fields="json_fields" name="Export Thaiking">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                                </download-excel>
                            </b-dropdown-item>
                            <b-dropdown-item>
                                <download-excel :data="dataExportThaiking" :fields="json_fields" name="Export All Thaiking">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel All
                                </download-excel>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <a-table :columns="columns" :dataSource="dataThaiking.provider" :loading="isLoading"
                    :row-selection="rowSelectionThaiking" rowKey='username' :pagination="pagination">
                </a-table>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h5>ข้อมูลการเติมเงิน-ถอนเงิน ผู้ให้บริการ Capital Pay</h5>
                <hr>
                <div class="card-header card-header-flex">
                    <div class="d-flex flex-column justify-content-center mr-auto">
                        <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
                            <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeysCapitalPay)"
                                v-clipboard:success="onCopyCapitalPay" v-clipboard:error="onError"><i
                                    class="fa fa-copy mr-1" />Copy!
                            </b-dropdown-item>
                            <b-dropdown-item @click="checkDataExcel(json_dataCapitalPay)">
                                <download-excel :data="json_dataCapitalPay" :fields="json_fields" name="Export CapitalPay">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                                </download-excel>
                            </b-dropdown-item>
                            <b-dropdown-item>
                                <download-excel :data="dataExportCapitalPay" :fields="json_fields" name="Export All CapitalPay">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel All
                                </download-excel>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <a-table :columns="columns" :dataSource="dataCapitalPay.provider" :loading="isLoading"
                    :row-selection="rowSelectionCapitalPay" rowKey='username' :pagination="pagination">
                </a-table>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h5>ข้อมูลการเติมเงิน-ถอนเงิน ผู้ให้บริการ First2Pay</h5>
                <hr>
                <div class="card-header card-header-flex">
                    <div class="d-flex flex-column justify-content-center mr-auto">
                        <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
                            <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeysFirst2Pay)"
                                v-clipboard:success="onCopyFirst2Pay" v-clipboard:error="onError"><i
                                    class="fa fa-copy mr-1" />Copy!
                            </b-dropdown-item>
                            <b-dropdown-item @click="checkDataExcel(json_dataFirst2Pay)">
                                <download-excel :data="json_dataFirst2Pay" :fields="json_fields" name="Export First2Pay">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                                </download-excel>
                            </b-dropdown-item>
                            <b-dropdown-item>
                                <download-excel :data="dataExportFirst2Pay" :fields="json_fields" name="Export All First2Pay">
                                    <i class="fa fa-file-excel-o mr-1" />Export Excel All
                                </download-excel>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <a-table :columns="columns" :dataSource="dataFirst2Pay.provider" :loading="isLoading"
                    :row-selection="rowSelectionFirst2Pay" rowKey='username' :pagination="pagination">
                </a-table>
            </div>
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
function CopyMe(TextToCopy) {
  var TempText = document.createElement('textarea')
  TempText.value = TextToCopy
  document.body.appendChild(TempText)
  TempText.select()
  document.execCommand('copy')
  document.body.removeChild(TempText)
}
export default {
  props: [
    'dataPeer2Pay',
    'dataHengPay',
    'dataThaiking',
    'dataCapitalPay',
    'dataFirst2Pay',
    'columns',
    'isLoading',
  ],
  // components: {
  //     data: {
  //         json_meta: [
  //             [
  //                 {
  //                     key: 'charset',
  //                     value: 'utf-8',
  //                 },
  //             ],
  //         ],
  //     },
  // },
  computed: {
    myVal() {
      if (this.ctr === 0) {
        this.reCountdown()
      }
      return this.ctr
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = this.dataPeer2Pay.provider.map((result) => {
                return result.username
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
    rowSelectionHengPay() {
      const { selectedRowKeysHengPay } = this
      return {
        selectedRowKeysHengPay,
        onChange: this.onSelectChangeHengPay,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysHengPay = this.dataHengPay.provider.map((result) => {
                return result.username
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysHengPay = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
    rowSelectionThaiking() {
      const { selectedRowKeysThaiking } = this
      return {
        selectedRowKeysThaiking,
        onChange: this.onSelectChangeThaiking,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysThaiking = this.dataThaiking.provider.map((result) => {
                return result.username
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysThaiking = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
    rowSelectionCapitalPay() {
      const { selectedRowKeysCapitalPay } = this
      return {
        selectedRowKeysCapitalPay,
        onChange: this.onSelectChangeCapitalPay,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysCapitalPay = this.dataCapitalPay.provider.map((result) => {
                return result.username
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysCapitalPay = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
    rowSelectionFirst2Pay() {
      const { selectedRowKeysFirst2Pay } = this
      return {
        selectedRowKeysFirst2Pay,
        onChange: this.onSelectChangeFirst2Pay,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysFirst2Pay = this.dataFirst2Pay.provider.map((result) => {
                return result.username
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysFirst2Pay = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
  },
  data() {
    return {
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
      selectedRowKeys: [],
      selectedRowKeysHengPay: [],
      selectedRowKeysThaiking: [],
      selectedRowKeysFirst2Pay: [],
      selectedRowKeysCapitalPay: [],
      pagination: { defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger: true },
      dataExport: [],
      dataExportHengPay: [],
      dataExportThaiking: [],
      dataExportCapitalPay: [],
      dataExportFirst2Pay: [],
      fileName: '',
      json_data: [],
      json_dataHengPay: [],
      json_dataThaiking: [],
      json_dataCapitalPay: [],
      json_dataFirst2Pay: [],
      json_fields: {
        ยูสเซอเนม: 'username',
        'เติมเงิน/บาท': 'amountDeposit',
        'เติมเงิน/ครั้ง': 'CountDeposit',
        'ถอนเงิน/บาท': 'amountWithdraw',
        'ถอนเงิน/ครั้ง': 'CountWithdraw',
      },
      refresh: false,
      countdown: false,
      timer: '',
      counters: '',
      counters2: '',
      ctr: 5,
    }
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.reload()
      }
    },
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
    dataPeer2Pay: function(value) {
      this.exportAll(value)
    },
    dataHengPay: function(value) {
      this.exportAllHengPay(value)
    },
    dataThaiking: function(value) {
      this.exportAllThaiking(value)
    },
    dataCapitalPay: function(value) {
      this.exportAllCapitalPay(value)
    },
    dataFirst2Pay: function(value) {
      this.exportAllFirst2Pay(value)
    },
    selectedRowKeysHengPay: function(val) {
      if (val) {
        this.dataToExcelHengPay(val)
      }
    },
    selectedRowKeysThaiking: function(val) {
      if (val) {
        this.dataToExcelThaiking(val)
      }
    },
    selectedRowKeysCapitalPay: function(val) {
      if (val) {
        this.dataToExcelCapitalPay(val)
      }
    },
    selectedRowKeysFirst2Pay: function(val) {
      if (val) {
        this.dataToExcelFirst2Pay(val)
      }
    },
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    copyLink(link) {
      CopyMe(link)
      Toast.fire({ icon: 'success', title: 'success copy' })
    },
    checkDataExcel(data) {
      if (data.length === 0) {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการ Export' })
        return false
      }
    },
    returnData(item) {
      return {
        username: item.username,
        amountDeposit: typeof item.CountDeposit !== 'undefined' ? item.CountDeposit.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0.00',
        CountDeposit: typeof item.CountDeposit !== 'undefined' ? item.CountDeposit.toFixed().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : 0,
        amountWithdraw: typeof item.amountWithdraw !== 'undefined' ? item.amountWithdraw.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0.00',
        CountWithdraw: typeof item.CountWithdraw !== 'undefined' ? item.CountWithdraw.toFixed().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : 0,
      }
    },
    dataToExcel(data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataPeer2Pay.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          dataresult.push(resultData)
        })
        this.json_data = dataresult
      }
    },
    dataToExcelHengPay(data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataHengPay.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          dataresult.push(resultData)
        })
        this.json_dataHengPay = dataresult
      }
    },
    dataToExcelThaiking(data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataThaiking.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          dataresult.push(resultData)
        })
        this.json_dataThaiking = dataresult
      }
    },
    dataToExcelCapitalPay(data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataCapitalPay.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          dataresult.push(resultData)
        })
        this.json_dataCapitalPay = dataresult
      }
    },
    dataToExcelFirst2Pay(data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataFirst2Pay.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          dataresult.push(resultData)
        })
        this.json_dataFirst2Pay = dataresult
      }
    },
    exportAll(value) {
      const obj = value.provider
      this.dataExport = []
      let resultData = {}
      obj.map(item => {
        resultData = this.returnData(item)
        this.dataExport.push(resultData)
      })
    },
    exportAllHengPay() {
      const obj = this.dataHengPay.provider
      this.dataExportHengPay = []
      let resultData = {}
      obj.map(item => {
        resultData = this.returnData(item)
        this.dataExportHengPay.push(resultData)
      })
    },
    exportAllThaiking() {
      const obj = this.dataThaiking.provider
      this.dataExportThaiking = []
      let resultData = {}
      obj.map(item => {
        resultData = this.returnData(item)
        this.dataExportThaiking.push(resultData)
      })
    },
    exportAllCapitalPay() {
      const obj = this.dataCapitalPay.provider
      this.dataExportCapitalPay = []
      let resultData = {}
      obj.map(item => {
        resultData = this.returnData(item)
        this.dataExportCapitalPay.push(resultData)
      })
    },
    exportAllFirst2Pay() {
      const obj = this.dataFirst2Pay.provider
      this.dataExportFirst2Pay = []
      let resultData = {}
      obj.map(item => {
        resultData = this.returnData(item)
        this.dataExportFirst2Pay.push(resultData)
      })
    },
    onCopy: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataPeer2Pay.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onCopyHengPay: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataHengPay.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onCopyThaiking: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataThaiking.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onCopyCapitalPay: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataCapitalPay.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onCopyFirst2Pay: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataFirst2Pay.provider.find((dataResult) => {
            if (dataResult.username === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onError: function (e) {
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onSelectChangeHengPay(selectedRowKeysHengPay) {
      this.selectedRowKeysHengPay = selectedRowKeysHengPay
    },
    onSelectChangeThaiking(selectedRowKeysThaiking) {
      this.selectedRowKeysThaiking = selectedRowKeysThaiking
    },
    onSelectChangeCapitalPay(selectedRowKeysCapitalPay) {
      this.selectedRowKeysCapitalPay = selectedRowKeysCapitalPay
    },
    onSelectChangeFirst2Pay(selectedRowKeysFirst2Pay) {
      this.selectedRowKeysFirst2Pay = selectedRowKeysFirst2Pay
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    getAutoRefresh(refresh) {
      if (!refresh) {
        this.refresh = true
        this.ReloadData(true)
      } else {
        this.refresh = false
        this.ReloadData(false)
      }
    },
    getDataProvider() {
      this.$emit('getData-table')
    },
    ReloadData(value) {
      if (value) {
        this.countdown = true
        this.counters = setInterval(function () {
          this.getDataProvider()
        }.bind(this), 5000)
        this.counters2 = setInterval(function () {
          this.ctr = this.ctr - 1
        }.bind(this), 1000)
      } else {
        clearInterval(this.counters)
        clearInterval(this.counters2)
        this.ctr = 5
      }
    },
    reload() {
      this.getDataProvider()
      this.$emit('clear-reload')
    },
    reCountdown() {
      this.ctr = 5
    },

  },
  async created() {
    // this.setData()
  },
}
</script>
